
/**
 * External dependencies
 */
 import classnames from 'classnames';

 /**
  * WordPress dependencies
  */
 import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { styles2cssV } from './funcs';


const save = props => {
    const {
        attributes
    } = props;

    const { 
        contentJustification, 
        orientation,
        styles
    } = attributes;
    

    return (
        <div
			{ ...useBlockProps.save( {
				className: classnames( {
					[ `is-content-justification-${ contentJustification }` ]: contentJustification,
					'wp-block-buba-blocks-buttons--vertical': orientation === 'vertical',
				} ),
                style: styles2cssV( styles, 'buba-blocks-buttons' )
			} ) }
		>
			<InnerBlocks.Content />
		</div>
    );
}

export default save;